import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Titulo } from 'src/app/models/fin/titulo/titulo';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TituloService extends AbstractIdbaService {
  override model: Titulo;

  constructor(http: HttpClient) {
    super(http, new Titulo());
    this.programName = "fin/titulo/titulo.p";
  }

  carregaLiquidacaoTitulo(registro: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-carrega-liquidacao-titulo';
    if (registro.listarPagamentos) {
      request.parameters = { ...registro }
    } else {
      request.parameters = { idTitulo: registro };
    }
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  consultaCheque(registro: any){
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-consulta-cheque';
    request.parameters = { rowid: registro.rowId };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: 'response' });
  }

  listaTitulos(param: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-listar';
    request.parameters = {
      ...param
    };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  salvaLiquidacaoTitulo(registro: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-salva-liquidacao-titulo';
    request.parameters = { registro: [registro] };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  salvaPagamentos(params: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-salva-pagamentos';
    request.parameters = params;
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  salvaCheque(params: any){
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-salvar-cheque';
    request.parameters = { cheques: [params] };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: 'response' });
  }

  ListarMovimentos(idTitulo: number) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-listar-movimentos';
    request.parameters = { idTitulo };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  LiquidacaoAutomatica(registro: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-liquidacao-automatica';
    request.parameters = { ...registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  excluirPagamento(rowid: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-excluir-pagamento';
    request.parameters = { rowid };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  donwloadBoleto(registro: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.procedure = 'pi-download-boleto';
    request.parameters = { rowid: registro };
    request.program = this.programName;
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  downloadRelatorio(registro: Titulo) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.procedure = 'pi-consulta-movimento-Titulo';
    request.parameters = registro;
    request.program = this.programName;
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }
  
  retornaTitulosSubstituidos(rowid: string) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-titulos-substituidos";
    request.parameters = { rowid };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: 'response' });
  }
  

  gerarRelatorio(filterObject: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.parameters = filterObject;

    if (filterObject.tipoTitulo === 1)
    {
      request.program = "fin/contasreceber/relatoriotitulosreceber.p";
      request.procedure = 'pi-gera-titulos-receber';
    }
    else
    {
      request.program = "fin/contaspagar/relatoriocontaspagar.p";
      request.procedure = 'pi-gera-contas-pagar'; 
    }

    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

}
